.logout__popover .ant-popover-inner {
  padding: 0;
}
